// extracted by mini-css-extract-plugin
export default {"header":"BaggageSegment-module__header____wXwi","listItem":"BaggageSegment-module__listItem___xMBgX"};